<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag
  [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">プロモ商品企画点検リスト</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <select class="combo-box-normal" id="cmb_MediumType" #cmb_MediumType
                [(ngModel)]="kymw1320Model.selectedMediumType" forcedEnabledMode="true" [tabindex]="0"
                (change)="eventMediumType_CHANGEHandler()">
                <ng-template ngFor let-item [ngForOf]="kymw1320Model.dispMediumTypeList">
                  <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
                </ng-template>
              </select>
              <app-radio-label label="1物N価" value="1" id="rbd_Nval" 
                [(ngModel)]="kymw1320Model.outputFlag" (change)="eventOutputFlag_CHANGEHandler()">
              </app-radio-label>
              <app-radio-label label="予約" value="2"  id="rbd_Preorder"
                [(ngModel)]="kymw1320Model.outputFlag" (change)="eventOutputFlag_CHANGEHandler()">
              </app-radio-label>
            </div>
            

            <label class="list-input-title">束ね企画名</label>
            <div class="list-input-content">
              <select id="cmb_BundleCatalogGuideStandardName" #cmb_BundleCatalogGuideStandardName
                forcedEnabledMode="true" [tabindex]="0" [(ngModel)]="kymw1320Model.selectBundleCatalogRound"
                [disabled]="isDisabledBundleCatalog" (change)="eventBundleCatalogGuideStandardName_CHANGEHandler()">
                <ng-template ngFor let-item [ngForOf]="kymw1320Model.dispBundleCatalogRoundInfoList">
                  <option value="{{item.BundleCatalogRoundId}}">{{item.BundleCatalogRoundName}}</option>
                </ng-template>
              </select>
              <input type="text" class="order-code" readonly [(ngModel)]="kymw1320Model.startBundleOrderCode">
              <label>～</label>
              <input type="text" class="order-code" readonly [(ngModel)]="kymw1320Model.endBundleOrderCode">
            </div>

            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input class="order-code" id="txt_StartOrderCode" #txt_StartOrderCode
                [subid]="'txt_StartOrderCode'" [forcedEnabledMode]="'true'" [tabindex]="0"
                [(ngModel)]="kymw1320Model.startOrderCode">
              </app-order-code-text-input>
              <label>～</label>
              <app-order-code-text-input class="order-code" id="txt_EndOrderCode" #txt_EndOrderCode
                [subid]="'txt_EndOrderCode'" [forcedEnabledMode]="'true'" [tabindex]="0"
                [(ngModel)]="kymw1320Model.endOrderCode">
              </app-order-code-text-input>
            </div>
          </div>

          <div class="element-row">
            <div class="column-list">
              <label class="list-input-title">Ｐコード</label>
              <input type="text" id="txt_PCode" #txt_PCode class="list-input-content pcode" forcedEnabledMode="true"
                [tabindex]="0" plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8"
                [(ngModel)]="kymw1320Model.pCode">
            </div>
            <div class="column-list">
              <label class="list-input-title">アイテムコード</label>
              <input type="text" id="txt_ItemCode" class="list-input-content" #txt_ItemCode forcedEnabledMode="true"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [tabindex]="0"
                [(ngModel)]="kymw1320Model.itemCode">
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">注文コード</label>
            <input type="text" class="list-input-content" id="txt_OrderNum" plessInputTextSub [restrict]="'[0-9]'"
              #txt_OrderNum forcedEnabledMode="true" [tabindex]="0" [(ngModel)]="kymw1320Model.orderNum"
              [maxlength]="6">
          </div>
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" forcedEnabledMode="true" [tabindex]="0"
            (click)="eventOutput_CLICKHandler()">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button id="btn_Close" forcedEnabledMode="true" [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>